import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function createScan({ niche, area, cap = 40 }) {
  const { data } = await api.post("/scans", { niche, area, cap });
  return data;
}

export async function getScan(scanId) {
  const { data } = await api.get(`/scans/${scanId}`);
  return data;
}

export async function getRecentScans(limit = 10) {
  const { data } = await api.get(`/scans/recent`, { params: { limit } });
  // Backend now returns {items, total}; older callers only care about items.
  return data.items || [];
}

export async function getScanHistory(limit = 200) {
  const { data } = await api.get(`/scans/recent`, { params: { limit } });
  return data;
}

export function scanExportUrl(scanId) {
  return `${API}/scans/${scanId}/export`;
}

export async function upsertLead(placeId, payload) {
  const { data } = await api.put(
    `/leads/${encodeURIComponent(placeId)}`,
    payload,
  );
  return data;
}

export async function fetchLeads(placeIds) {
  if (!placeIds || placeIds.length === 0) return {};
  const { data } = await api.get(`/leads`, {
    params: { place_ids: placeIds.join(",") },
  });
  return data.items || {};
}

export async function fetchCallbackAgenda() {
  const tz =
    (typeof Intl !== "undefined" &&
      Intl.DateTimeFormat().resolvedOptions().timeZone) ||
    "UTC";
  const { data } = await api.get(`/leads/callbacks`, { params: { tz } });
  return data;
}

export async function fetchLeadsSummary() {
  const tz =
    (typeof Intl !== "undefined" &&
      Intl.DateTimeFormat().resolvedOptions().timeZone) ||
    "UTC";
  const { data } = await api.get(`/leads/summary`, { params: { tz } });
  return data;
}

export async function prospectingSearch(keywords) {
  const { data } = await api.post(`/prospecting/search`, { keywords });
  return data;
}

export async function listProspectingRuns(limit = 30) {
  const { data } = await api.get(`/prospecting/runs`, { params: { limit } });
  return data;
}

export async function getProspectingRun(runId) {
  const { data } = await api.get(`/prospecting/runs/${runId}`);
  return data;
}

export async function deleteProspectingRun(runId) {
  const { data } = await api.delete(`/prospecting/runs/${runId}`);
  return data;
}
